/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import styled from 'styled-components';
import { Card } from 'react-bootstrap';

const cardShadow = `0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)`;
const cardShadowHover = `0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22)`;
const transition = `all 0.3s cubic-bezier(.25,.8,.25,1)`;
const checkSize = `20px`;

export const SectionContainer = {
  backgroundColor: '#f2f5f8',
};

export const SectionNameStyle = {
  fontSize: '10px',
  color: '#a1aab9',
};

export const AppCard = styled(Card)`
  cursor: pointer;
  transition: ${transition};
  border: 4px solid transparent;
  transition: ${transition};
  box-shadow: ${cardShadow};
  height: 100%;
  background-color: ${(props) => props?.background ?? '#fafafa'};
  &:hover {
    background-color: ${(props) => props?.hoverColor ?? '#fafafa'};
    box-shadow: ${cardShadowHover};
  }
`;

export const AppCardTitleImageStyle = {
  width: 80,
  height: 80,
};

export const DescriptionStyle = styled.p`
  fontsize: 0.9rem;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
`;

export const HeadingStyle = {
  fontSize: '1.0rem',
  overflow: 'hidden',
  color: '#0f0f0f',
  fontWeight: 'bold',
  display: '-webkit-box,',
  '-webkit-line-clamp': 2,
  textOverflow: 'ellipsis',
  lineClamp: 2,
  '-webkit-box-orient': 'vertical',
};
